import axios from "axios";
import { PUBLIC_SESSION_CONFIG } from "./publicAccountSession";

export function getPublicCreditHistory() {
  return axios.get("/api/public/account/credit-history", PUBLIC_SESSION_CONFIG);
}

export function getPublicCreditHistoryPayload(response) {
  const payload = response?.data?.data || response?.data || {};
  return {
    success: payload.success !== false,
    authenticated: payload.authenticated === true,
    historyCompleteFrom: payload.history_complete_from || null,
    transactions: Array.isArray(payload.transactions) ? payload.transactions : [],
    error: payload.error || null,
  };
}
